import {noop, twMerge} from '@sdox/utils'

import styles from './textLink.module.scss'

import type {ComponentProps} from 'react'

export const textLinkStyles = styles

export interface TextLinkProps extends ComponentProps<'a'> {
  variant?: 'default' | 'inversed'
}

const variantStyles: Record<NonNullable<TextLinkProps['variant']>, string> = {
  'default': styles.default,
  'inversed': styles.inversed,
}

export const TextLink = ({
  className,
  variant = 'default',
  children,
  href = '#',
  onClick = noop,
  ...restProps
}: TextLinkProps) => (
  <a
    href={href}
    className={twMerge(
      styles.textLink,
      variantStyles[variant],
      className,
    )}
    data-testid={'_a'}
    onClick={onClick}
    {...restProps}
    rel={'noopener noreferrer'}
  >
    {children}
  </a>
)
